import React from 'react';

import styled from 'styled-components';

import Domains from '@lcsc-ui/utils/domains';

const HeaderWrapper = styled.header`
  .meun-item {
    position: relative;
    &.active,
    &:hover {
      border-bottom: 3px solid #0093e6;
      color: #0093e6;
    }
  }
`;

const MallDataHeader = ({ currentPageName }) => {
  const menus = [
    { menuName: '首页', menuUrl: Domains.lcscWwwUrl, active: false, spm: 'hm' },
    {
      menuName: '企业简介',
      menuUrl: Domains.lcscWwwUrl + '/about.html',
      active: currentPageName === 'about',
      spm: 'ab',
    },
    {
      menuName: '代理品牌',
      menuUrl: Domains.lcscWwwUrl + '/agent.html',
      active: currentPageName === 'agent',
      spm: 'ag',
    },
    { menuName: '加入我们', menuUrl: Domains.lcscWwwUrl + '/join.html', active: currentPageName === 'join', spm: 'jo' },
    {
      menuName: '联系我们',
      menuUrl: Domains.lcscWwwUrl + '/contact.html',
      active: currentPageName === 'contact',
      spm: 'co',
    },
  ];
  return (
    <HeaderWrapper className="w-full bg-white h-[64px] flex items-center sticky top-0 z-10 shadow-[0_2px_4px_0px_rgba(149,156,176,0.21)]">
      <section className="w-[1200px] mx-auto flex justify-between">
        <a data-spm="lo" href={Domains.lcscWwwUrl} className="logo flex items-center">
          <img src="//static.szlcsc.com/ecp/assets/web/common/images/logo4.png" alt="立创商城logo" width={150} />
        </a>
        <ul className="menu h-[50px] flex items-center text-center text-[16px]">
          {menus.map((menu) => (
            <a
              className={`meun-item h-full leading-[50px] mx-[20px] ${menu.active && 'active'}`}
              href={menu.menuUrl}
              key={menu.menuUrl}
              data-spm={menu.spm}
            >
              {menu.menuName}
            </a>
          ))}
        </ul>
      </section>
    </HeaderWrapper>
  );
};

export default MallDataHeader;
